import NinjaCartLogo from "./NinjaCartLogo";
import SvgLoader from "./SvgLoader";
import { useTheme } from "./useTheme";
import classNames from "classnames";
import React from "react";

const loaderSize = [
  {
    size: "xsm",
    class: "h-10 w-10 ",
    imgSize: 14,
  },
  {
    size: "sm",
    class: "h-12 w-12",
    imgSize: 14,
  },
  {
    size: "md",
    class: "h-14 w-14 p-6",
    imgSize: 18,
  },
  {
    size: "lg",
    class: "h-16 w-16",
    imgSize: 20,
  },
  {
    size: "xl",
    class: "h-20 w-20",
    imgSize: 27,
  },
  {
    size: "xxl",
    class: "h-24 w-24",
    imgSize: 32,
  },
];

export const useLoader = (props) => {
  const { variantType, color, size, logoColor, borderWidth = 8, logoCustomClasses } = props;

  const styles = useTheme(props);

  const getLoader = () => {
    if (variantType === "ninja") {
      const result = loaderSize.find((d) => d?.size === size);
      return (
        <div className='relative flex justify-center'>
          <div
            style={{ borderTopColor: color, borderWidth: `${borderWidth}px` }}
            className={`loader border-[#f3f3f3] rounded-full ${result?.class} ${logoCustomClasses} animate-spin-slow `}
          />
          <NinjaCartLogo
            className='top-1/2 left-1/2 absolute'
            style={{ transform: "translate(-50%, -50%)", left: "50%" }}
            width={result?.imgSize}
            height={result?.imgSize}
            color={logoColor}
          />
        </div>
      );
    }
    if (variantType === "dottedCircle") {
      return (
        <SvgLoader
          className={classNames(`${["animate-spin-slow m-auto", styles.loaderSize].join(" ")}`)}
          color={color}
        />
      );
    }
  };

  const LoaderComponent = getLoader();

  return {
    LoaderComponent,
  };
};
